import { render, staticRenderFns } from "./surveys.table.vue?vue&type=template&id=f072a616&"
import script from "./surveys.table.vue?vue&type=script&lang=js&"
export * from "./surveys.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports